<template><div class="columns">
  <div class="column is-one-fifth">
    <aside class="menu">
      <p class="menu-label">
        Games lists
      </p>
      <ul class="menu-list">
        <li v-for="list in lists" :key="list.id">
            <router-link :to="{ name: 'client-games-lists-list', params: { listId: list.id } }" active-class="is-active"><a>{{list.name}}</a></router-link>
        </li>
        <li>
            <router-link :to="{ name: 'client-games-lists-list', params: { listId: 'new' } }"><a>Create</a></router-link>
        </li>
      </ul>
    </aside>
  </div>
  <div class="column">
    <router-view />
  </div>
</div>
</template>
<script>
import gamesListService from '../../../../services/gamesList.service';

export default {
    name: 'client-games-lists',
    data() {
        return {
            lists: []
        };
    },
    computed: {
        clientId() {
            return Number(this.$route.params.clientId);
        }
    },
    watch: {
        async $route () {
            await this.loadLists();
        }
    },
    async mounted() {
        await this.loadLists();
    },
    methods: {
        async loadLists() {
            this.lists = await gamesListService.getClientGamesLists(this.clientId);
        }
    }
};
</script>
<style>
</style>



// WEBPACK FOOTER //
// front/src/components/clients/client/games/lists.vue